/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ImpersonationRequest } from '../models/impersonation-request';
import { SiteContextListResponse } from '../models/site-context-list-response';
import { SiteContextUpdateRequest } from '../models/site-context-update-request';

@Injectable({
  providedIn: 'root',
})
export class MeControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /**
   * Path part for operation updateSiteContext
   */
  static readonly UpdateSiteContextPath = '/me/site-context';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateSiteContext()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSiteContext$Response(
    params: {
      body: SiteContextUpdateRequest;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      MeControllerService.UpdateSiteContextPath,
      'put'
    );
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({
          responseType: 'text',
          accept: '*/*',
          context: context,
        })
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return (r as HttpResponse<any>).clone({
            body: undefined,
          }) as StrictHttpResponse<void>;
        })
      );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateSiteContext$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSiteContext(
    params: {
      body: SiteContextUpdateRequest;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.updateSiteContext$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation impersonate
   */
  static readonly ImpersonatePath = '/me/impersonation-context';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `impersonate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  impersonate$Response(
    params: {
      body: ImpersonationRequest;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      MeControllerService.ImpersonatePath,
      'put'
    );
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({
          responseType: 'text',
          accept: '*/*',
          context: context,
        })
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return (r as HttpResponse<any>).clone({
            body: undefined,
          }) as StrictHttpResponse<void>;
        })
      );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `impersonate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  impersonate(
    params: {
      body: ImpersonationRequest;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.impersonate$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation removeImpersonation
   */
  static readonly RemoveImpersonationPath = '/me/impersonation-context';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeImpersonation()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeImpersonation$Response(
    params?: {},
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      MeControllerService.RemoveImpersonationPath,
      'delete'
    );
    if (params) {
    }

    return this.http
      .request(
        rb.build({
          responseType: 'text',
          accept: '*/*',
          context: context,
        })
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return (r as HttpResponse<any>).clone({
            body: undefined,
          }) as StrictHttpResponse<void>;
        })
      );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `removeImpersonation$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeImpersonation(params?: {}, context?: HttpContext): Observable<void> {
    return this.removeImpersonation$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation getSiteContexts
   */
  static readonly GetSiteContextsPath = '/me/available-site-contexts';

  /**
   * Gets current merchant's choosable site contexts.
   *
   * Finds and returns every possible combination of sites and non rejected merchant types.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSiteContexts()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSiteContexts$Response(
    params?: {},
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<SiteContextListResponse>>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      MeControllerService.GetSiteContextsPath,
      'get'
    );
    if (params) {
    }

    return this.http
      .request(
        rb.build({
          responseType: 'json',
          accept: 'application/json',
          context: context,
        })
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<Array<SiteContextListResponse>>;
        })
      );
  }

  /**
   * Gets current merchant's choosable site contexts.
   *
   * Finds and returns every possible combination of sites and non rejected merchant types.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSiteContexts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSiteContexts(
    params?: {},
    context?: HttpContext
  ): Observable<Array<SiteContextListResponse>> {
    return this.getSiteContexts$Response(params, context).pipe(
      map(
        (r: StrictHttpResponse<Array<SiteContextListResponse>>) =>
          r.body as Array<SiteContextListResponse>
      )
    );
  }
}
